import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ArrowDownIcon, HomeIcon, InventoryIcon, OrdersIcon, DSOPricingIcon, SettingsIcon, LogoutIcon, LinkIcon } from './Styles/Icons';
import { LogoutButton, MenuContainer, MenuDrawer, MenuItem, SupplierContainer, Popover, PopoverBody, PopoverItem, PopoverTitle, Search, Hidden } from './Styles/Menu';

import { changeTile } from '../../actions/changeTile';
import { toggleDrawer } from '../../actions/toggleDrawer';
import { updateSupplier } from '../../actions/supplierActions';
import { logout } from '../../actions/userActions';
import { checkLabSeller } from '../../commons/utils';

const PopoverIds = {
	SUPPLIER: 'supplier',
};

const DentalMenu = [
	{
		key: 'HOME',
		label: 'Home',
		icon: <HomeIcon />,
		link: '/',
	},
	{
		key: 'INVENTORY',
		label: 'Inventory',
		icon: <InventoryIcon />,
		link: '/inventoryV2',
	},
	{
		key: 'ORDERS',
		label: 'Orders',
		icon: <OrdersIcon />,
		link: '/ordersV2',
	},
	{
		key: 'SETTINGS',
		label: 'Settings',
		icon: <SettingsIcon />,
		link: '/settingsV2',
	},
	{
		key: 'DSO_PRICING',
		label: 'DSO Pricing',
		icon: <DSOPricingIcon />,
		link: '/dsopricing',
	},
];

const LabMenu = [
	{
		key: 'INVENTORY',
		label: 'Inventory',
		icon: <InventoryIcon />,
		link: '/',
	},
	{
		key: 'DSO_PRICING',
		label: 'DSO Pricing',
		icon: <DSOPricingIcon />,
		link: '/dsopricing',
	},
	{
		key: 'AI_SKU_MAPPING',
		label: 'AI SKU Mapping',
		icon: <LinkIcon style={{ transform: 'rotate(-45deg)' }} />,
		link: '/aiSkuMapping',
	},
];

class Menu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: '',
			drawerOpen: false,
			supplier: '',
			supplierList: [],
			supplierPopoverAnchorElement: null,
			supplierSearchText: '',
			supplierPopoverItem: '',
		};
	}

	componentDidMount() {
		if (this.state.selected !== this.props.tile) {
			this.setState({
				selected: this.props.tile,
			});
		}

		if (this.props.history.action === 'POP') {
			this.forceUpdate();
		}
	}

	componentDidUpdate() {
		if (this.state.selected !== this.props.tile) {
			this.setState({
				selected: this.props.tile,
			});
		}

		if (this.props.supplierList !== this.state.supplierList) {
			this.setState({
				supplierList: this.props.supplierList,
			});
		}

		if (this.props.supplier !== this.state.supplier) {
			this.setState({
				supplier: this.props.supplier,
			});
		}
	}

	onMenuItemClickHandler = (item) => {
		this.setState({
			selected: item,
		});
		this.props.changeTile(item);
		this.props.toggleDrawer(false);
	};

	handlePopoverClick = async (popoverId, event) => {
		switch (popoverId) {
			case PopoverIds.SUPPLIER:
				this.setState({
					supplierPopoverAnchorElement: event.currentTarget,
				});
				break;

			default:
				break;
		}
	};

	handlePopoverSelect = async (popoverId, choice) => {
		switch (popoverId) {
			case PopoverIds.SUPPLIER:
				if (choice !== this.state.supplier) {
					this.props.updateSupplier(choice);
				}
				break;

			default:
				break;
		}
		this.handlePopoverClose(popoverId);
	};

	handlePopoverClose = async (popoverId) => {
		switch (popoverId) {
			case PopoverIds.SUPPLIER:
				this.setState({
					supplierPopoverAnchorElement: null,
				});
				break;

			default:
				break;
		}
	};

	render() {
		let { selected, supplierList, supplier, supplierPopoverAnchorElement, supplierPopoverItem, supplierSearchText } = this.state;
		let { open, supplierMap, isLabSeller } = this.props;

		let menuItems = DentalMenu;
		if (isLabSeller) {
			menuItems = LabMenu
		}

		let supplierOptions = supplierList
			.map((supplier, index) => {
				return {
					name: supplierMap[supplier] && supplierMap[supplier].name ? supplierMap[supplier].name : supplier,
					value: supplier,
					disabled: false,
				};
			})
			.sort((option1, option2) => (option1.name || option1.value).localeCompare(option2.name || option2.value));

		let MenuContent = (
			<>
				<SupplierContainer onClick={supplierOptions.length > 1 ? (e) => this.handlePopoverClick(PopoverIds.SUPPLIER, e) : null}>
					{supplierMap[supplier] && supplierMap[supplier].name ? supplierMap[supplier].name : supplier}
					{supplierOptions.length > 1 ? <ArrowDownIcon /> : null}
				</SupplierContainer>

				{menuItems.map((item, index) => (
					<MenuItem
						key={index}
						to={item.link}
						selected={selected === item.key}
						onClick={(e) => this.onMenuItemClickHandler(item.key)}
					>
						{item.icon} {item.label}
					</MenuItem>
				))}

				<LogoutButton
					onClick={(e) => {
						this.props.logout();
					}}
				>
					<LogoutIcon style={{ transform: 'rotate(180deg)', verticalAlign: 'text-top' }} />
					Logout
				</LogoutButton>
			</>
		);

		return (
			<>
				<Popover
					id={PopoverIds.SUPPLIER}
					open={Boolean(supplierPopoverAnchorElement)}
					anchorEl={supplierPopoverAnchorElement}
					onClose={() => this.handlePopoverClose(PopoverIds.SUPPLIER)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					<PopoverTitle>Select Supplier</PopoverTitle>

					<PopoverItem>
						<Search
							searchText={supplierSearchText}
							placeholder={'Search Supplier'}
							searchOnChange={true}
							onSearchHandler={(value) =>
								this.setState({
									supplierSearchText: value,
								})
							}
						/>
					</PopoverItem>

					<PopoverBody style={{ maxHeight: '80vh' }}>
						{supplierOptions.map((item, index) => {
							return item.name.toUpperCase().includes((supplierSearchText || '').toUpperCase()) ? (
								<PopoverItem
									key={index}
									disabled={item.disabled || item.value === supplierPopoverItem}
									onClick={(e) => this.handlePopoverSelect(PopoverIds.SUPPLIER, item.value)}
								>
									{item.name}
								</PopoverItem>
							) : null;
						})}
					</PopoverBody>
				</Popover>

				<MenuContainer>{MenuContent}</MenuContainer>

				<Hidden lgUp>
					<MenuDrawer
						anchor='left'
						open={open}
						onClose={(e) => {
							this.props.toggleDrawer(!open);
						}}
					>
						{MenuContent}
					</MenuDrawer>
				</Hidden>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tile: state.tiles.tile,
		supplierMap: state.supplier.suppliers_map,
		supplierList: state.supplier.suppliers_list,
		supplier: state.supplier.supplier,
		open: state.drawer.isOpen,
		isLabSeller: checkLabSeller(state?.session?.user_type),
	};
};

const mapDispatch = {
	changeTile,
	updateSupplier,
	logout,
	toggleDrawer,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(Menu));
